import { useEffect, useState } from 'react'
import { Applicant, MultisectorData } from 'store/dashboard/types'
import { Box, Checkbox, FormControlLabel, FormGroup, Paper } from '@mui/material'
import SectionSubTitle from '../../../components/SectionSubtitle'
import { useAdminQuery } from 'containers/dashboard/multisectorReport/hooks/useAdminQuery'

type Props = {
  data: MultisectorData
  subgroups: string[]
  onSubgroupsSelectedChange: (selectedSubgroups: string[]) => void
  target: Applicant
}

export default function SectorsFilterComponent({ data, subgroups, onSubgroupsSelectedChange, target }: Props) {
  const [subgroupsSelected, setSubgroupsSelected] = useState<string[]>([])
  const isAdminView = useAdminQuery().isAdminView
  useEffect(() => {
    setSubgroupsSelected(subgroups)
    onSubgroupsSelectedChange(subgroups)
  }, [subgroups])

  // Función para manejar el cambio de los checkboxes
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target

    setSubgroupsSelected(prevSelected => {
      const newSelected = checked ? [...prevSelected, value] : prevSelected.filter(item => item !== value)

      // Notificar al componente padre del cambio
      onSubgroupsSelectedChange(newSelected)

      return newSelected
    })
  }

  const get_subgroup_percent = (subgroup_code: string) => {
    const total_patents = target.whales_patent_count || 0

    if (total_patents === 0) return 0

    const whales_count_by_ipcr = target.whales_count_by_ipcr || {}
    const subgroup_patents = whales_count_by_ipcr[subgroup_code] || 0

    return (subgroup_patents / total_patents) * 100
  }

  return (
    <Paper variant="outlined" sx={{ borderRadius: '20px', m: 3, mt: 0 }}>
      <SectionSubTitle title="Sectors" />

      {isAdminView && (
        <div>
          (Admin:)Total patents: {target.whales_patent_count} | Patents in categories: {target.whales_patents_in_categories}
        </div>
      )}

      <Box px={3} pb={2}>
        <FormGroup>
          {subgroups.map(subgroupCode => {
            const subgroupInfo = data.info.subgroups_info.find(sub => sub.code === subgroupCode)
            const subgroupTitle = subgroupInfo?.claude_main_title || subgroupCode
            return (
              <FormControlLabel
                key={subgroupCode}
                control={
                  <Checkbox
                    value={subgroupCode}
                    checked={subgroupsSelected.includes(subgroupCode)}
                    onChange={handleCheckboxChange}
                  />
                }
                label={
                  <span style={{ fontSize: '14px' }}>
                    {isAdminView && subgroupCode + ' - ' + target.whales_count_by_ipcr?.[subgroupCode] + ' patents -'}
                    {get_subgroup_percent(subgroupCode).toFixed(2)}% - {subgroupTitle}
                  </span>
                }
              />
            )
          })}
        </FormGroup>
      </Box>
    </Paper>
  )
}
